import numeral from 'numeral';
import * as currencies from './currencies.json';

// Todo: write a better class to manage global/current app/state currency.

let currency = 'USD';
let symbol = '$';

export function setGlobalCurrency(c) {
    if (currencies[c]) {
        currency = c;
        symbol = currencies[c].symbol_native;
    }
}

export function getGlobalCurrencySymbol() {
    return symbol;
}

export function formatCurrency(num, minDecimals = 0, maxDecimals = 0) {
    if ((num == '' || num == undefined) && (num != 0 && num != '0')) {
        return '';
    }

    let val = parseFloat(num);
    if (val == 0) {
        return `${symbol}0`;
    }

    let neg = false;
    if (val < 0) {
        neg = true;
        val = Math.abs(val);
    }

    let format = `(0,0.${'0'.repeat(minDecimals)})`;
    return `${neg ? '-' : ''}${symbol}${numeral(val).format(format)}`;

    return val.toLocaleString(
        undefined,
        {
            style: 'currency',
            currency,
            minimumFractionDigits: minDecimals || 0,
            maximumFractionDigits: Math.max(minDecimals, maxDecimals)
        }
    );
}

export function shortFormatCurrency(num) {
    if (isNaN(num)) return '';

    num = parseFloat(num);
    // see if we should include a decimal:
    let includeDecimal = false;
    let sNum = num.toString();
    if (sNum.length > 1) {
        if (sNum[1] != '0') {
            includeDecimal = true;
        } else if (sNum.length > 2 && sNum[2] != '0') {
            // if third digit is not 0, and can be rounded up, should include decimal.
            if (parseInt(sNum[2]) >= 5) {
                includeDecimal = true;
            }
        }
    }

    let neg = false;
    if (num < 0) {
        neg = true;
        num = Math.abs(num);
    }
    let format = includeDecimal ? (num < 1000 ? `(0.00a)` : `(0.0a)`) : `(0a)`;
    return `${neg ? '-' : ''}${symbol}${numeral(num).format(format)}`;
}
